import { createTheme, ThemeOptions } from '@mui/material/styles';
import type { } from '@mui/x-date-pickers/themeAugmentation';

const options: ThemeOptions = {
  palette: {
    mode: 'light',
    background: {
      default: '#FBFBFB',
      paper: '#FFFFFF',
    },
    primary: {
      main: '#2A61FF',
      light: '#E6EDFF',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FFFFFF',
      contrastText: '#000',
    },
    divider: '#e3e3e5',
  },
  typography: {
    fontWeightLight: 300,
    fontFamily: 'Inter',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontSize: 13,
    button: {
      textTransform: 'none',
      fontWeight: 'normal',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          fontWeight: 'light',
        },
        outlined: {
          color: 'black',
          borderColor: 'black',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          input: {
            padding: '8px',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: 'none',
        fullWidth: true,
        slotProps: {
          inputLabel: {
            shrink: true,
          },
        },
      },
    },
    MuiDatePicker: {
      defaultProps: {
        sx: {
          ".MuiPickersSectionList-root": {
            py: '8px',
          }
        },
        slotProps: {
          textField: {
            fullWidth: true,
            InputLabelProps: {
              shrink: true,
            },
          }
        }
      }
    },
    MuiDateTimePicker: {
      defaultProps: {
        sx: {
          ".MuiPickersSectionList-root": {
            py: '8px',
          }
        },
        slotProps: {
          textField: {
            fullWidth: true,
            InputLabelProps: {
              shrink: true,
            },
          }
        }
      }
    },
    MuiTimePicker: {
      defaultProps: {
        sx: {
          ".MuiPickersSectionList-root": {
            py: '8px',
          }
        },
        slotProps: {
          textField: {
            fullWidth: true,
            InputLabelProps: {
              shrink: true,
            },
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          padding: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          textTransform: 'uppercase',
          background: '#EBEBEB',
        },
      },
    },
    MuiPagination: {
      defaultProps: {
        shape: 'rounded',
        color: 'primary',
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px',
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },

    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
      defaultProps: {
        disableGutters: true,
        sx: {
          p: 0,
        },
      },
    },
  },
};

export const defaultTheme = createTheme(options);
